import React from 'react';
import { useTranslation } from 'react-i18next';
import Box from '../../shared/atoms/Box';
import Heading from '../../shared/atoms/Heading';
import Separator from '../../Separator';
import BuyGiftCardCustomization from './BuyGiftCardCustomization';

// Icons
import BuyGiftCardSteps from './BuyGiftCardSteps';
import BuyGiftCardRecapPay from './BuyGiftCardRecapPay';
import BuyGiftCardConfirmation from './BuyGiftCardConfirmation';

const BuyGiftCardHeroBox = ({
  client,
  giftcard,
  setGiftcard,
  setShowModal,
  loading,
  setLoading,
  steps,
  setSteps,
}) => {
  const { t } = useTranslation();
  const nextStep = async () => {
    if (steps === 'CUSTOMIZATION') {
      let error = false;
      if (
        giftcard.amount === 0 &&
        (giftcard.customAmount === '' || giftcard.customAmount == 0)
      ) {
        setGiftcard((s) => {
          return { ...s, errorAmount: t('buygiftcardhero.text.1') };
        });
        error = true;
      }
      if (!giftcard.recipientName) {
        setGiftcard((s) => {
          return {
            ...s,
            errorName: t('buygiftcardhero.text.2'),
          };
        });
        error = true;
      }
      if (!error) setSteps('RECAP');
    }
    if (steps === 'RECAP') {
      setSteps('CONFIRMATION');
    }
  };

  const previousStep = () => {
    if (steps === 'RECAP') {
      setSteps('CUSTOMIZATION');
    }
  };

  return (
    <Box
      p={{ xs: 0, md: 7 }}
      mr={{ xs: 0, md: 5 }}
      mb={11}
      bg="white"
      boxShadow={{ xs: null, md: 'lg' }}
      borderRadius="md"
      mt={{ xs: 0, md: -10 }}>
      <Box flexDirection={{ xs: 'column', lg: 'row' }}>
        <BuyGiftCardSteps steps={steps} flex={3} />
        <Box flex={2} />
      </Box>
      <Separator axe="horizontal" />
      {steps === 'CUSTOMIZATION' && (
        <>
          <Heading level={3}>{t('buygiftcardhero.headings.1')}</Heading>
          <Box flexDirection={{ xs: 'column', lg: 'row' }}>
            <BuyGiftCardCustomization
              giftcard={giftcard}
              setGiftcard={setGiftcard}
              nextStep={nextStep}
            />
          </Box>
        </>
      )}
      {steps === 'RECAP' && (
        <>
          <Heading level={3}>{t('buygiftcardhero.headings.2')}</Heading>
          <Box flexDirection={{ xs: 'column', lg: 'row' }}>
            <BuyGiftCardRecapPay
              giftcard={giftcard}
              setGiftcard={setGiftcard}
              nextStep={nextStep}
              previousStep={previousStep}
              client={client}
              loading={loading}
              setLoading={setLoading}
              setShowModal={setShowModal}
            />
          </Box>
        </>
      )}
      {steps === 'CONFIRMATION' && (
        <>
          <Heading level={3}>{t('buygiftcardhero.headings.3')}</Heading>
          <BuyGiftCardConfirmation giftcard={giftcard} />
        </>
      )}
    </Box>
  );
};

export default BuyGiftCardHeroBox;
